export const FETCH_FEATURES_REQUEST = 'FEATURES/FETCH_FEATURES_REQUEST';
export const SET_FEATURES = 'FEATURES/SET_FEATURES';
export const SET_FEATURES_LOADED = 'FEATURES/SET_FEATURES_LOADED';
export const SET_RESOLVED_FLAGS = 'FEATURES/SET_RESOLVED_FLAGS';
